import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Box, Flex, Tab, TabContext, TabList, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const BASE_PATH = '/qbank-structures/search-by-keywords';

const TAB_ITEMS: { value: string; label: string; path: string }[] = [
  { label: 'ค้นหาด้วย Keyword', value: 'keyword', path: BASE_PATH },
  { label: 'ค้นหาด้วย QID', value: 'qid', path: `${BASE_PATH}/qid` },
];

export default function SearchByKeywordsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith('/qid') ? 'qid' : 'keyword';

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
        APP_PERMISSIONS.QBANK.DASHBOARD.VIEW,
        APP_PERMISSIONS.QBANK.LOS.VIEW,
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.QBANK.SETTING.VIEW,
        APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          minHeight: '100dvh',
          bgcolor: (theme) => theme.palette.grey[50],
        }}
      >
        <Box
          sx={(theme) => ({
            bgcolor: theme.palette.common.white,
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
          })}
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(4),
              px: 6,
              pt: 8,
            })}
          >
            <Text variant='h1'>ค้นหาข้อสอบ</Text>
            <TabContext value={activeTab}>
              <TabList
                onChange={(_, newValue) => {
                  if (newValue === activeTab) return;
                  const tab = TAB_ITEMS.find((t) => t.value === newValue);
                  if (tab) navigate(tab.path);
                }}
              >
                {TAB_ITEMS.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    sx={{ minWidth: 'unset', fontSize: '16px' }}
                  />
                ))}
              </TabList>
            </TabContext>
          </Flex>
        </Box>

        <Flex sx={{ flexDirection: 'column', flexGrow: 1, p: 6 }}>
          <Outlet />
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
